export default "__VITE_ASSET__c6175b5f__"